import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export type IntelligenceGroupBy = 'unit' | 'driver' | 'client';

@Injectable({
    providedIn: 'root'
})
export class UnitIntelligenceService {

    api_url = environment.url;

    constructor(private http: HttpClient) { }

    private toQueryString(params: any = {}): string {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return queryString ? `?${queryString}` : '';
    }

    getDashboard(params: any = {}) {
        return this.http.get(`${this.api_url}unit/intelligence/dashboard${this.toQueryString(params)}`);
    }

    getRanking(groupBy: IntelligenceGroupBy, params: any = {}) {
        return this.http.get(`${this.api_url}unit/intelligence/ranking/${groupBy}${this.toQueryString(params)}`);
    }

    getHistory(groupBy: IntelligenceGroupBy, id: number, params: any = {}) {
        return this.http.get(`${this.api_url}unit/intelligence/history/${groupBy}/${id}${this.toQueryString(params)}`);
    }

    getServiceDetail(groupBy: IntelligenceGroupBy, id: number, serviceId: number) {
        return this.http.get(`${this.api_url}unit/intelligence/history/${groupBy}/${id}/detail/${serviceId}`);
    }

    getStatuses() {
        return this.http.get(`${this.api_url}status`);
    }

    getMaintenanceHistory(unitId: number, params: any = {}) {
        return this.http.get(`${this.api_url}unit/maintenance-history/${unitId}${this.toQueryString(params)}`);
    }
}
